// password.js
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
//import AuthService from '../services/authService'; // Adjust path as needed
import { api } from '../axios/AxiosInstances';
import { Footer } from './Footer';
const Password = () => {
  const position = 'absolute'
  const [hideOld, setHideOld] = useState(true);
  const [hideNew, setHideNew] = useState(true);
  const [hideConfirm, setHideConfirm] = useState(true);
  const [showInfo, setShowInfo] = useState(false);
  const [message, setMessage] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { register, handleSubmit, watch } = useForm();

  const validateSavePassword = (data) => {
    const { newpassword, confirmpassword, oldpassword, username } = data;

    if (newpassword !== confirmpassword) {
      setError("Passwords don't match");
      return;
    }

    const errors = [];
    if (newpassword.length < 8) errors.push("Must be at least 8 characters long");
    if (!/[a-z]/.test(newpassword)) errors.push("Must include at least one lowercase letter (a-z)");
    if (!/[A-Z]/.test(newpassword)) errors.push("Must include at least one uppercase letter (A-Z)");
    if (!/\d/.test(newpassword)) errors.push("Must include at least one number");
    if (!/[!@#$%^&*+.?"={}|_-]/.test(newpassword)) errors.push("Must include at least one non-alphanumeric character (!@#$%^&*()_-+={}[]|)");

    if (errors.length > 0) {
      alert("Please Check Password:\n" + errors.join('\n'));
      return;
    }

    savePassLogin({ oldpassword, newpassword, username });
  };

  const savePassLogin = async (values) => {
    try {
      const res = await api.post('/changepasswordlogin', values);
      console.log("sameer",res)

      if (res.data.status === 'passwordchanged') {
        alert('Password changed successfully!');
        navigate('/login');
      } else if (res.data.status === 'passwordwrong' || res.status === 'usernotfound') {
        setError('User name or password entered is incorrect');
      } 
    } catch (err) {
      setError('Server error');
    }
  };

  const handleInfoClick = () => {
    setMessage([
      'Must be at least 8 characters long',
      'Must include at least one lowercase letter (a-z)',
      'Must include at least one uppercase letter (A-Z)',
      'Must include at least one number',
      'Must include at least one non-alphanumeric character (!@#$%^&*+.?"={}|_-)' 
    ]);
    setShowInfo(true);
  };

  const closePopup = () => {
    setShowInfo(false);
  };

  return (
    <div className="container d-flex justify-content-center" style={{ marginTop: '20px' }}>
      <form onSubmit={handleSubmit(validateSavePassword)} style={{ width: '100%', maxWidth: '500px' }}>
        <div className="mb-3 d-flex align-items-center">
          <label className="username" style={{ marginRight: '10%' }}>Username <span style={{ color: 'red' }}>*</span></label>
          <input className="form-control" {...register('username', { required: true })} />
        </div>

        <div className="mb-3 d-flex align-items-center">
          <label className="oldpass" style={{ marginRight: '6%' }}>Old Password <span style={{ color: 'red' }}>*</span></label>
          <input className="form-control me-2" type={hideOld ? 'password' : 'text'} {...register('oldpassword', { required: true })} />
          <img src={hideOld ? '/assets/Group265.svg' : '/assets/Group1567.svg'} onClick={() => setHideOld(!hideOld)} alt="toggle" style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
        </div>

        <div className="mb-3 d-flex align-items-center">
          <label className="newpass"style={{ marginRight: '5%' }}>New Password <span style={{ color: 'red' }}>*</span></label>
          <input className="form-control me-2" type={hideNew ? 'password' : 'text'} {...register('newpassword', { required: true })} />
          <img src={hideNew ? '/assets/Group265.svg' : '/assets/Group1567.svg'} onClick={() => setHideNew(!hideNew)} alt="toggle" style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
          <img src="/assets/icons8-info.svg" onClick={handleInfoClick} alt="info" style={{ marginLeft: '8px', cursor: 'pointer', width: '20px', height: '20px' }} />
        </div>

        <div className="mb-3 d-flex align-items-center">
          <label className="me-2">Confirm Password <span style={{ color: 'red' }}>*</span></label>
          <input className="form-control me-2" type={hideConfirm ? 'password' : 'text'} {...register('confirmpassword', { required: true })} />
          <img src={hideConfirm ? '/assets/Group265.svg' : '/assets/Group1567.svg'} onClick={() => setHideConfirm(!hideConfirm)} alt="toggle" style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <div className="text-center mt-3">
          <button type="submit" className="btn me-3" style={{ color: '#fff', backgroundColor: '#337ab7', borderColor: '#2e6da4' }}>Save</button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/login')} style={{ color: '#fff', backgroundColor: '#337ab7', borderColor: '#2e6da4' }}>Exit</button>
        </div>

        {showInfo && (
          <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50">
            <div className="bg-white p-4 rounded" style={{ maxWidth: '400px' }}>
              <div className="d-flex justify-content-end">
                <button onClick={closePopup} className="btn-close"></button>
              </div>
              <p><strong>Password should follow these rules:</strong></p>
              <ul>
                {message.map((msg, i) => (
                  <li key={i}>{msg}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </form>
      <Footer position={position} />
    </div>
  );
};

export default Password;
